import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12 flex flex-col items-center justify-center">
        <div className="flex flex-row items-center justify-start gap-4">
          {/* Logo */}
          {/* <Logo size="small" responsive={true} /> */}
          {/* Navigation */}
          <div className="flex flex-col items-start justify-start gap-4">
            <h3 className='text-white text-lg font-bold'>주식회사 비지리츠</h3>
            <p className='text-white text-sm'>사업자등록번호: 513-87-02354</p>
          </div>
        </div>
        {/* Links */}
        <div className="flex flex-row items-center justify-center gap-6 mt-8">
          <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
            이용약관
          </Link>
          <span className="text-gray-600">|</span>
          <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
            개인정보보호방침
          </Link>
        </div>
        {/* Copyright */}
        <div className="border-gray-800 text-center mt-4">
          <p className="text-gray-400">
            © 2025 EnglishPT. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 